export const RenewCategories = (fields) => {
  return ({
    type: 'RENEW_CATEGORIES',
    payload: fields,
  });
};

export const SaveSelectedCategories = (fields) => {
  return ({
    type: 'SELECTED_CATEGORIES_DATA',
    payload: fields,
  });
};

export const SaveCategoriesForm = () => {
  return ({
    type: 'GET_CATEGORIES_DATA',
  });
};

export default { SaveSelectedCategories, RenewCategories };
